export const AVAILABLE_LOCALES = ['en', 'de', 'es', 'fr', 'nl', 'it'];
export const CURATED_SET_ROW_LENGTH = 4;
export const CURRENCY_SYMBOLS = {
  usd: '&#36;',
  eur: '&#8364;',
  gbp: '&#163;',
  jpy: '&#165;',
  aud: '&#36;',
  cad: '&#36;',
};

export const SIDEBAR_TRACK_NAME = 'GridFacetsSidebar';

export const FOLLOWABLE_CATEGORIES = [
  '62835d2e-ac92-41fc-9b8d-4aba8c1c25d5',
  '3ca3eb03-7eac-477d-b253-15ce603d2550',
  '09055aa7-ed49-459d-9452-aa959f288dc2',
  '032c74d0-b0e2-4442-877f-e1a22438a7fa',
  '53a9c7d7-d73d-4e7f-905c-553503e50a90',
  '58d889f7-0aa1-4689-a9d3-da16dd225e8d',
  'b3cb9f8e-4cb6-4325-8215-1efcd9999daf',
  'fa10f97c-dd98-4a8f-933b-8cb55eb653dd',
  'dfd39027-d134-4353-b9e4-57dc6be791b9',
  'fb60628c-be4b-4be2-9c0f-bc5d31e3996c',
  '40e8bfd0-3021-43f7-b104-9d7b19af5c2b',
  'd002db05-ab63-4c79-999c-d49bbe8d7739',
  '1f99c852-9d20-4fd3-a903-91da9c805a5e',
  'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e',
  'e71b6e43-7217-4746-b4e3-64bf708a2664',
];

export const NEWSLETTER_LIST_ID = '5889ed6702';

export const PRICE_ASC_SORT = 'price|asc';
export const DEFAULT_CONDITION = 'all';
export const DEFAULT_EMPTY_GRID_ROWS = 2;
export const DEFAULT_PAGE = 1;
export const EVERYWHERE_CODE = 'XX';
export const US_CON_CODE = 'US_CON';
export const NEW_CONDITION = 'new';
export const USED_CONDITION = 'used';
export const MAKE_ROUTE_PATH = 'brand/:brand_slug';
export const CSP_INDEX_ROUTE = 'popular-products';
export const SALE_ROUTE_PATH = 'sales/:curated_set_slug';
export const ITEM_SHOW_ROUTE_PATH = 'item/:id';
export const ITEM2_SHOW_ROUTE_PATH = 'i2/:id';
export const ITEM_PREVIEW_PATH = 'preview/:id';
export const ITEM_PREVIEW_CONFIRM_PATH = 'preview/:id/confirm';
export const HANDPICKED_ROUTE_PATH = 'handpicked/:curated_set_slug';
export const PERSONAL_HANDPICKED_ROUTE_PATH = 'profile/:profile_slug/handpicked/:curated_set_slug';
export const PROFILE_FOLLOWERS_ROUTE_PATH = 'profile/:profile_slug/followers';
export const MARKETPLACE_PATH = 'marketplace';
export const PRODUCT_TYPE_PARAM = 'product_type';
export const CATEGORY_UUID_PARAM = 'category_uuid';
export const PAGE_PARAM = 'page';
export const CATEGORY_PARAM = 'category';
export const LP_NATIVE = 'lp_native';
export const IOS = 'ios';
export const ANDROID = 'android';
export const SELLER_LOCATION_FILTER = 'seller_location';
export const BRAND_NEW_CONDITION = 'brand-new';

export const LISTING_STATES = {
  DRAFT: 'draft',
  ENDED: 'ended',
  EXPIRED: 'expired',
  LIVE: 'live',
  ORDERED: 'ordered',
  SELLER_UNAVAILABLE: 'seller_unavailable',
  SOLD: 'sold',
  SOLD_OUT: 'sold_out',
  SUSPENDED: 'suspended',
  UPCOMING: 'upcoming',
};

export const experiments = {
  CATEGORY_FLYOUT: 'category_flyout',
  ITEM_PRICE_NUDGE_BADGE: 'item_price_nudge_badge',
  CSP_FINISHES_SELLFLOW: 'csp_finishes_sellflow',
  FEED_POSTGRES_READS: 'feed_postgres_reads',
  ITEM_LOGGED_OUT_RECENTLY_VIEWED: 'item_logged_out_recently_viewed',
  OFFER_QUANTITY: 'offer_quantity',
  SHIPPING_PROTECTION_SELLER_QUOTE: 'shipping_protection_seller_quote',
  TRAIT_FACETS: 'trait_facets',
  ITEM_V2: 'item_v2',
  BLOCKED_FROM_FLAGGING_EXPERIMENT: 'blocked_from_flagging_listings',
  QUICK_SHIPPER_SPEED_NUDGE: 'quick_shipper_speed_nudge',
  ITEM2_ENDED_LISTING: 'item2_ended_listing',
  ITEM2_PAID_LANDING: 'item2_paid_landing',
  DEPRECATE_NESTED_MARKETPLACE_3: 'deprecate_nested_marketplace_3',
  DUMMY: 'dummy',
  MV_DUMMY: 'mv_dummy',
  MORE_MARKETPLACE_BUMP_REAL_ESTATE: 'more_marketplace_bump_real_estate',
  RECENTLY_VIEWED_ROWS: 'rc_vw_rows',
  REVERB_PROTECTION_CART: 'reverb_protection_cart',
  CSP_ALL_IN_PRICE_SORT: 'csp_all_in_price_sort',
  CSP_BUYBOX_LAUNCH: 'csp_buybox_launch',
  GENERIC_CSP_SHOW_NEW: 'generic_csp_show_new',
  NEO_MARKETPLACE: 'neo_marketplace',
  BEARER_V_2_0: 'bearer_v_2_0',
  I2_COMBINED_SHIPPING_CALLOUT: 'i2_combined_shipping_callout',
  FEATURED_LISTING_CARD_V3: 'featured_listing_card_v3',
  ITEM2_FEEDBACK_FILTERS: 'item2_feedback_filters',
  ONE_COLUMN_CSP: 'one_column_csp',
  SECONDARY_ITEM_ROWS: 'secondary_item_rows',
  I2_MESSAGE_SELLER: 'i2_message_seller',
  NEW_CSP_ROW_TITLE: 'new_csp_row_title',
  DEALS_FILTERS: 'deals_filters',
  PRIVACY_SETTINGS: 'privacy_settings',
  BUYER_FREE_SHIPPING_THRESHOLD: 'buyer_free_shipping_threshold',
  AFFIRM_CALLOUTS_BATCH1: 'affirm_callouts_batch1',
  I2_REVERB_PROTECTION_CALLOUT: 'i2_reverb_protection_callout',
  ACCEPTS_AFFIRM_FILTER: 'accepts_affirm_filter',
  AFFIRM_EXPLORE_LINKS: 'affirm_explore_links',
  MARKETPLACE_TRAIT_FILTERS: 'marketplace_trait_filters',
};

export const pills = {
  CATEGORIES_NAME: 'categories',
  DECADES_NAME: 'decades',
  US_CON_REGION: 'US_CON',
  DEFAULT_REGION: 'XX',
  MAKES_NAME: 'makes',
  MULTI_SELECT_TYPE: 'multi_select',
  RANGE_TYPE: 'range',
  OPEN_INPUT_TYPE: 'open_input',
  PLACEHOLDER_TYPE: 'placeholder',
};

export const cloudinaryTransforms = {
  H300_W600: 'a_exif,c_fill,f_auto,fl_progressive,g_north,h_300,q_auto:eco,w_600',
  H226_W226: 'a_exif,c_thumb,fl_progressive,g_south,h_226,q_auto:eco,w_226',
};

export const RECENT_SEARCH = 'recentSearch';

export const FOLLOW_PROMPT_PARAM = 'follow_prompt';
export const LEGACY_OFFERS_LISTING_TYPE = 'offers';

export const SALE_BUYER_INELGIBILITY_REASONS = {
  NOT_STARTED: 'sale_not_started',
  ENDED: 'ended',
  MUST_BE_FIRST_PURCHASE: 'must_be_first_purchase',
  MUST_BE_ON_MOBILE: 'must_be_on_mobile',
  MUST_BE_ACTIVATED: 'must_be_activated',
  MUST_BE_STUDENT: 'must_be_student',
  NOT_FIRST_SALE_PURCHASE: 'not_first_sale_purchase',
  TIME_EXPIRED: 'time_expired',
  LOGIN_REQUIRED: 'login_required',
  LOGIN_REQUIRED_SHOW_INVENTORY: 'login_required_show_inventory',
  GENERIC: 'not_eligible',
};

export const EXPERIMENT_VALUES = {
  CTL: 'ctl',
  EXP1: 'exp1',
  EXP2: 'exp2',
  EXP3: 'exp3',
};

export const PAYMENT_PROCESSING_FEES = {
  STANDARD: 2.7,
  PREFERRED_SELLER: 2.5,
};

export const ARTICLE_PAGE_TYPE = 'article';
export const CRATE_PAGE_TYPE = 'crate';
// eslint-disable-next-line max-len
export const CORE_DEFAULT_OG_IMAGE_URL = 'https://static.reverb-assets.com/assets/homepage/open-graph-2a0cbbc49a26d873db03aae487defc6d.jpg';
export const LISTING_GUIDELINES_URL = 'https://help.reverb.com/hc/articles/360013231013';

export const SLEEVE_CONDITION_UUID = '09d0e8c9-e2db-4e9d-8097-62e3bdbd6534';
export const MEDIA_CONDITION_UUID = 'c9479c1a-ff31-4328-92fd-04e495e97c10';

export const MEDIA_CONDITIONS = Object.freeze({
  MINT: '2981e0e5-5770-48d8-89ab-ed4b378da220',
  NEAR_MINT: '7e6bbb82-419f-48d3-b7cd-d196cfa8ed34',
  VERY_GOOD_PLUS: '38d7284f-09bb-4d49-8dc0-6f9fb4469fea',
  VERY_GOOD: '8eec19fb-01cc-466e-b1d5-c7405f8e9538',
  GOOD_PLUS: '8945e258-e249-4c98-86d9-305f5b2098ca',
  GOOD: '06230b7a-3f8b-40a4-978b-dcdc87598fcb',
  FAIR: '896c4b33-03ea-44b4-990e-7f023d97d519',
  POOR: 'e25cdf2b-3595-4631-817f-7fc0bdac8bf4',
});

export const SLEEVE_CONDITIONS = Object.freeze({
  MINT: '6e70b061-c753-44d5-9968-e717266685da',
  NEAR_MINT: '4613cedd-0a63-4b08-a1ea-6cce4fcdc069',
  VERY_GOOD_PLUS: 'b965e14a-ece9-4287-9e27-d282af7326e4',
  VERY_GOOD: 'b0d3ffd0-81e1-4f45-a91a-a449c05bd6da',
  GOOD_PLUS: 'aac035ae-68bd-4f38-93ea-0cfaab1ffec9',
  GOOD: '1b1739f8-0d17-4692-8a8f-8e23fe2cb57c',
  FAIR: 'cf94f5a0-9b48-4f66-afc4-438ec3ed8e4e',
  POOR: '489bdbe7-9f5f-4075-859b-3da0bb9f4bf3',
  GENERIC: 'eb767f2f-cafc-4215-a823-8fe0329c0310',
  NO_COVER: '0c6a3224-bd9c-40da-a2a1-e640a0631aa4',
});

export const MINT_CONDITIONS = [
  'mint',
  'mint-inventory',
];

export const LP_CATEGORY_UUID = 'b891b5df-051c-4ee1-ac91-c9a38f62ef90';

export const FLAG_LISTING_REASONS = {
  FRADULENT: 'fradulent',
  INCORRECT_PRODUCT_INFO: 'incorrect_product_information',
  TRADEMARK_INFRINGEMENT: 'trademark_infringement',
  VIOLATES_GUIDELINES: 'guidelines_violation_html',
};

export const MIN_BUMP_AMOUNT_PERCENT = 0.5;
export const MAX_BUMP_AMOUNT_PERCENT = 30;
export const BUMP_INCREMENT_AMOUNT_PERCENT = 0.5;

// Languages for locale picker
export const LANGUAGES = {
  en: 'English',
  fr: 'Français',
  ja: '日本語',
  es: 'Español',
  de: 'Deutsch',
  it: 'Italiano',
  eo: 'Esperanto',
};

export const MARKETPLACE_TRAIT_FILTERS = [
  '9a355c89-c810-446e-be9f-0def8ef9dad5', // electric-guitars--body-shape
  'b05df9b7-a6c9-4230-8c67-b32f530b77b4', // electric-guitars--body-type
  '6a24e2dc-800d-4f06-ac67-acef9569a40f', // guitars--fretboard-material
  'c78557ac-fc14-46bc-abce-5c746680e7b2', // guitars--left-right-handed
  '64dbf67b-2fa8-48f7-9762-c6b445ac6a46', // guitars--number-of-strings
  'bf7ec187-1221-4179-9018-8bb70f711e97', // pro-audio_microphones--microphone-type
  '49a51cf1-a002-40dd-a7e7-2a1c614e75bf', // pro-audio_microphones--wired-slash-wireless
  '0b796742-6dd8-4fbd-8c58-a60c0fe7fbb9', // pro-audio_microphones--polar-pattern
  'a2e78ca8-9312-4fd3-84fc-de56add15f2e', // pro-audio--audio-electronics
  '0ce4c380-f8d9-46f3-a9d9-5e843ba64c07', // pro-audio--product-format
  '9f5af791-6dd3-45d7-9a47-4a48dbcc5c8d', // pro-audio_interfaces--computer-connectivity
  'f0e24355-ca60-4fcd-ae44-375476c660f5', // pro-audio_interfaces--compatibility
  '7ee1a472-1072-4347-8142-de6b9d1b9577', // pro-audio_interfaces--bus-powered
];

export default {
  SALE_BUYER_INELGIBILITY_REASONS,
  AVAILABLE_LOCALES,
  CORE_DEFAULT_OG_IMAGE_URL,
  CURATED_SET_ROW_LENGTH,
  CURRENCY_SYMBOLS,
  DEFAULT_CONDITION,
  DEFAULT_EMPTY_GRID_ROWS,
  DEFAULT_PAGE,
  EVERYWHERE_CODE,
  US_CON_CODE,
  NEW_CONDITION,
  USED_CONDITION,
  MAKE_ROUTE_PATH,
  CSP_INDEX_ROUTE,
  SALE_ROUTE_PATH,
  ITEM_SHOW_ROUTE_PATH,
  ITEM_PREVIEW_PATH,
  ITEM_PREVIEW_CONFIRM_PATH,
  MARKETPLACE_PATH,
  PRODUCT_TYPE_PARAM,
  CATEGORY_UUID_PARAM,
  CATEGORY_PARAM,
  experiments,
  pills,
  cloudinaryTransforms,
  RECENT_SEARCH,
  EXPERIMENT_VALUES,
  PAYMENT_PROCESSING_FEES,
  ARTICLE_PAGE_TYPE,
  CRATE_PAGE_TYPE,
  LANGUAGES,
  MARKETPLACE_TRAIT_FILTERS,
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/constants.js